import { ValidationErrors } from "../../hooks";
import { getSpacing } from "../../theme";
import { Stack, Typography } from "../mui";

export const GeneralValidationErrors = (props: { errors: ValidationErrors | string[] }) => {
  return (
    <Stack direction="column" spacing="xs" pb={getSpacing("md")}>
      {Array.isArray(props.errors)
        ? props.errors.map((error) => (
            <Typography key={error} color="error" variant="caption">
              - {error}
            </Typography>
          ))
        : Object.entries(props.errors).map(([key, value]) => (
            <Typography key={key} color="error" variant="caption">
              - {key}: {value.toString()}
            </Typography>
          ))}
    </Stack>
  );
};
